import { Link } from 'react-router-dom';

// Grouped sections (matches THEMES file's small-uppercase header style).
// Order matters — players hit More most often for Trip Plan items, less
// often for Capture, rarely for Finances, only-when-needed for Emergency.
const SECTIONS = [
  {
    id: 'trip_plan',
    label: 'Trip Plan',
    items: [
      { to: '/excursions', label: 'Excursions', hint: 'Whale watch · Mendenhall canoe · Endicott Arm' },
      { to: '/activities', label: 'Hiking', hint: 'AllTrails-powered · condition-ranked' },
      { to: '/drives', label: 'Drives', hint: 'Out the Road · North Douglas · Thane · Mendenhall Loop' },
      { to: '/packing', label: 'Packing', hint: 'Per-person checklists' },
    ],
  },
  {
    id: 'capture',
    label: 'Capture',
    items: [
      { to: '/trip-roll', label: 'Trip Roll', hint: 'Off-challenge memory frames · feeds the slideshow' },
      { to: '/field-assistant', label: 'Field Assistant', hint: 'Personal Claude chat with trip tools' },
      { to: '/photo-coaching', label: 'Photo Coaching', hint: 'Settings tables + Wilman audio per scenario' },
      { to: '/transmissions', label: 'Transmissions Log', hint: 'Replay every Wilman moment from the trip' },
      { to: '/settings', label: 'TARS Settings', hint: 'Tune Wilman’s voice for your ear (humor / honesty / sarcasm)' },
    ],
  },
  {
    id: 'finances',
    label: 'Finances',
    items: [
      { to: '/costs', label: 'Costs', hint: 'Expenses · receipt OCR · group settlement' },
    ],
  },
  {
    id: 'emergency',
    label: 'Emergency',
    items: [
      { to: '/sos', label: 'SOS', hint: 'Emergency surface · works offline', tone: 'danger' },
    ],
  },
];

export default function More() {
  return (
    <div className="mx-auto w-full max-w-screen-sm space-y-6 p-4">
      <header>
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-fg-tertiary">
          secondary tabs
        </p>
        <h1 className="mt-1 font-serif text-2xl">More</h1>
      </header>

      {SECTIONS.map((section) => (
        <section key={section.id} aria-labelledby={`more-${section.id}`} className="space-y-2">
          <h2
            id={`more-${section.id}`}
            className="font-mono text-[10px] uppercase tracking-[0.2em] text-fg-tertiary"
          >
            {section.label}
          </h2>
          <ul className="card divide-y divide-border-tertiary">
            {section.items.map((item) => (
              <li key={item.to}>
                <Link
                  to={item.to}
                  className={[
                    'flex items-center justify-between px-4 py-3 transition hover:bg-bg-tertiary',
                    item.tone === 'danger' ? 'text-danger' : '',
                  ].join(' ')}
                >
                  <div>
                    <p className="font-medium">{item.label}</p>
                    <p className="font-mono text-[10px] uppercase tracking-wider text-fg-tertiary">
                      {item.hint}
                    </p>
                  </div>
                  <span aria-hidden className="text-fg-tertiary">›</span>
                </Link>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  );
}
